import { memo as Memo, useState, useRef, useMemo, useCallback } from 'react'

//* HOC's
import withUIContext from 'context/consumerHOC/UIConsumer'

//* Components
import Image from 'components/common/Image'
import Video from 'components/common/Video'
import Icon from 'components/common/Icon'

//* Style
import FullWidthStyle from './style'

const FullWidth = Memo(({ className, file, winWidth }) => {
	//! State
	const [play, setPlay] = useState(true)

	//! Ref
	// const videoRef = useRef()

	const handleClick = useCallback(() => {
		if (play) {
			// videoRef?.current?.play()
			setPlay(false)
		} else {
			// videoRef?.current?.pause()
			setPlay(true)
		}
	}, [play])

	const videoSection = useMemo(() => {
		return (
			<div className={`videoWrapper`}>
				<Video
					className={`${play ? 'videoPlayIconAnim' : 'videoPauseIconAnim'}`}
					src={file.url}
					autoplay={false}
					loop={true}
					controls={false}
					handleClick={handleClick}
					muted={false}
				/>
				<Icon onClick={handleClick} className={`videoIcons ${play ? 'bb-play' : 'bb-pause'}`} />
			</div>
		)
	}, [winWidth, play])

	return (
		<FullWidthStyle className={`${className || ''} ${file.type === 'image' ? 'imageMarginSize' : ''}`}>
			{file.type === 'image' ? <Image priority src={file.url} alt={file.alt} /> : videoSection}
		</FullWidthStyle>
	)
})

export default withUIContext(FullWidth, ['winWidth'])
